 
namespace TabAurous.Purchase{
     
    @Serenity.Decorators.registerClass()
    export class PurchaseItemsRegisterGrid extends Serenity.EntityGrid<PurchaseItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseItemsRegister'; }
        protected getDialogType() { return PurchaseItemsDialog; }
        protected getIdProperty() { return PurchaseItemsRow.idProperty; }
        protected getInsertPermission() { return PurchaseItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }
        protected getService() { return PurchaseItemsService.baseUrl; }
        private treeMixin: Serenity.TreeGridMixin<PurchaseItemsRow>;


        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            
            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Pieces'),
                    new Slick.Aggregators.Sum('Weight'),
                    new Slick.Aggregators.Sum('NetWeight'),
                    new Slick.Aggregators.Sum('GrossAmount')]
            });


            this.view.setGrouping([{
                formatter: g => {
                    return "<span class='slick-group-title-header'>" +
                        g.value +
                        "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Pieces + "</span></span>" +
                        "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Weight.toFixed(3) + "</span></span>" +
                        "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.NetWeight + "</span></span>" +
                        "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.GrossAmount + "</span></span>" ;
                },
                getter: 'VoucherNo',
                displayTotalsRow: false,
            }])
            return grid;
        }
        protected usePager() {
            return true;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/PurchaseItems/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/PurchaseItems/ProductList',
                    idField: "ProductCode",
                    textField: "ProductCode",
                    multiple: true
                },
                field: 'ProductId',
                title: 'Product Code',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as TransactionRequest).ProductCodes = temp;
                        }
                    } else
                        (this.view.params as TransactionRequest).ProductCodes = temp;
                },
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/PurchaseItems/CategoryList',
                    idField: "CategoryName",
                    textField: "CategoryName",
                    multiple: true


                },
                field: 'CategoryId',
                title: 'Category',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as TransactionRequest).CategoryNames = temp;
                        }
                    } else
                        (this.view.params as TransactionRequest).CategoryNames = temp;
                },
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/PurchaseItems/SubCategoryList',
                    idField: "SubCategoryName",
                    textField: "SubCategoryName",
                    multiple: true


                },
                field: 'SubCategoryId',
                title: 'Sub Category',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as TransactionRequest).SubCategoryNames = temp;
                        }
                    } else
                        (this.view.params as TransactionRequest).SubCategoryNames = temp;
                },
                cssClass: 'hidden-xs'
            });

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            }); 

            return filters;
        } 
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.PurchaseRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date:this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Purchase Items",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }

      
    }
}